<template>
    <div class="relative flex size-full flex-nowrap items-center px-0 py-2 xl:py-6">
        <template v-if="isMobile">
            <div class="grow">
                <div class="flex w-full items-center">
                    <div class="my-4 grow border-r border-gray-300">
                        <Sidebar />
                    </div>
                    <div class="px-6 md:pr-6">
                        <SelectLanguage></SelectLanguage>
                    </div>
                </div>
                <div v-show="route.matched[0].name === ROUTES.WIZARD" class="w-full border-t px-4 pb-2 pt-4">
                    <LoginButton />
                </div>
            </div>
        </template>
        <template v-else>
            <div class="grid w-full grid-cols-4 items-center justify-between">
                <div class="col-span-3 flex w-full items-center justify-between">
                    <div class="flex items-center">
                        <template v-if="clinicLogo">
                            <div :class="['flex h-[65px] w-[165px] items-center justify-center', wizardStore.canGoBack ? 'cursor-pointer' : '']" @click="onGoHome()">
                                <img :src="clinicLogo" alt="logo_img" class="max-h-full max-w-full" />
                            </div>
                            <div class="mx-5 my-0 flex flex-col gap-1">
                                <h1 v-show="wizardStore.getSelectedClinic?.name" class="text-xl font-normal text-header-title-c">{{ wizardStore.getSelectedClinic?.name }}</h1>
                                <h3 v-show="wizardStore.getSelectedClinic?.title" class="text-base font-normal leading-4 text-header-subtitle-c">{{ wizardStore.getSelectedClinic?.title }}</h3>
                            </div>
                        </template>
                        <template v-else>
                            <div :class="['flex h-[65px] items-center justify-center', wizardStore.canGoBack ? 'cursor-pointer' : '']" @click="onGoHome()">
                                <div class="mx-5 my-0 flex flex-col gap-1">
                                    <h1 v-show="wizardStore.getSelectedClinic?.name" class="text-xl font-normal text-header-title-c">{{ wizardStore.getSelectedClinic?.name }}</h1>
                                    <h3 v-show="wizardStore.getSelectedClinic?.title" class="text-base font-normal leading-4 text-header-subtitle-c">{{ wizardStore.getSelectedClinic?.title }}</h3>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-show="route.matched[0].name === ROUTES.WIZARD" class="w-fit">
                        <LoginButton />
                    </div>
                </div>
                <div class="ml-auto w-fit">
                    <SelectLanguage></SelectLanguage>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import LoginButton from '@/components/LoginButton.vue';
import SelectLanguage from '@/components/SelectLanguage.vue';
import { ROUTES } from '@/enums/RoutesEnum';
import Sidebar from '@/layout/components/Sidebar.vue';
import { useWizardStore } from '@/stores/wizard';
import { fileUrl } from '@/utils/fileUrl';

const breakpoints = useBreakpoints(breakpointsTailwind);
const wizardStore = useWizardStore();
const router = useRouter();
const route = useRoute();

const isMobile = breakpoints.smaller('xl');

const clinicLogo = computed(() => {
    // Check if logo url is valid
    if (wizardStore.getSelectedClinic?.logo) {
        const img = new Image();
        img.src = fileUrl(wizardStore.getSelectedClinic?.logo, 100, 100, 0);
        img.onerror = fallbackToDefault;
        return img.src;
    } else {
        return '';
    }
});

const fallbackToDefault = () => {
    // Return default logo
    return '/images/logo-black.png';
};

const onGoHome = () => {
    if (wizardStore.canGoBack) {
        router.push({ name: ROUTES.CLINIC_SELECTION });
    }
};
</script>
